// Components
import ListboxInput from 'components/inputs/listbox'
// Data
import notifcationService from 'data/notification'
import propertyReportService from "data/reports-property"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Button_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

interface ValuationProps {
  property: object
}

const Valuation: FC<ValuationProps> = (props) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const valuationScenarios = props['property']['valuationdetail'];
  const [valuationPeriod, setValuationPeriod] = useState<any>([]);

  const valuationData = _.map(valuationScenarios, v => {
    let obj = {
      label: `#${v.valuationPeriod}: ${v.valuationDescription}`,
      value: v.valuationPeriod
    }
    if (v.defaultScenario) obj.label += ' (Default)'
    return obj
  });

  useEffect(() => {
    updateValuationPeriod([_.find(valuationScenarios, {'defaultScenario': true}).valuationPeriod]);
  }, [props['property']])

  function submit():void {
    propertyReportService.propertyReport({
      report: 'property_valuation',
      params: { valuationPeriod }
    })
  }

  function toggleScenarios():void {
    valuationPeriod.length > 0 ? setValuationPeriod([]) : setValuationPeriod(valuationData.map(v => v.value))
  }

  function updateValuationPeriod(value:any):void {
    const valuationScenarios = props['property']['valuationdetail'];
    for (let i of value){
      let scenario = _.find(valuationScenarios, {valuationPeriod: i});
      if (scenario.term > propertyReportService.getUnderwritingTermMax(scenario)){
        notifcationService.notify({
          type: "warn",
          message: "Insufficient property term to run the requested valuation scenario.  Please increase Property Settings Term and retry.",
          dismiss: 5000
        });
        setValuationPeriod(value);
        setDisabled(true);
        return;
      }
    }
    if (disabled) setDisabled(false);
    setValuationPeriod(value);
  }

  const calcdisabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Insufficient Property Term': calcdisabled ? 'Calculation Required' : 'Run Report'

  return (
    <div>
      <ButtonWithPress_s primary disabled={disabled || calcdisabled || valuationPeriod.length === 0} onClick={submit} style={{marginBottom: 20}}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <div style={{display: 'flex'}}>
            <Label_s style={{marginRight: 15}}>Valuation Scenario</Label_s>
            <Button_s onClick={toggleScenarios} style={{marginBottom: 10}}>{valuationPeriod.length > 0 ? 'Deselect All' : 'Select All'}</Button_s>
          </div>
          <ListboxInput field="valuationPeriod" value={valuationPeriod} options={valuationData} persist={(field:string, val:number)=>updateValuationPeriod(val)} multiple={true} />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default Valuation
